import { useEffect, useState } from "react";

/**
 * Displays the dynamically generated robots.txt at /robots.txt without changing the URL.
 * (For best crawler compatibility on custom domains, serve /robots.txt at the edge.)
 */
export default function Robots() {
  const [txt, setTxt] = useState<string>("");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const run = async () => {
      try {
        const domain = window.location.hostname;
        const baseUrl = import.meta.env.VITE_SUPABASE_URL;
        if (!baseUrl) throw new Error("Missing backend URL");

        const res = await fetch(
          `${baseUrl}/functions/v1/generate-robots?domain=${encodeURIComponent(domain)}`,
          { headers: { Accept: "text/plain,*/*;q=0.8" } },
        );

        const text = await res.text();
        if (!res.ok) throw new Error(text || `Request failed (${res.status})`);
        setTxt(text);
      } catch (e) {
        const message = e instanceof Error ? e.message : "Unknown error";
        setError(message);
      }
    };

    run();
  }, []);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <p className="text-muted-foreground">Error generating robots.txt: {error}</p>
      </div>
    );
  }

  if (!txt) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-muted-foreground">Generating robots.txt...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen p-6">
      <pre className="text-xs whitespace-pre-wrap break-words">{txt}</pre>
    </div>
  );
}

